import { gql } from 'urql';

export const LIST_TICKETS = gql`
  query ListTickets($pagination: PaginationInput, $filters: TicketFilterInput) {
    listTickets(pagination: $pagination, filters: $filters) {
      items {
        id
        asunto
        estado
        prioridad
        clienteId
        referenciaTipo
        referenciaId
        canal
        creadoEn
        actualizadoEn
        categoria {
          id
          nombre
        }
        sla {
          slaNombre
          promesaHoras
          mttaMin
          mttrMin
          cumplido
        }
      }
      pageInfo {
        total
        limit
        offset
      }
    }
  }
`;

export const GET_TICKET = gql`
  query GetTicket($id: ID!) {
    getTicket(id: $id) {
      id
      asunto
      descripcion
      estado
      prioridad
      canal
      clienteId
      referenciaTipo
      referenciaId
      asignadoAUserId
      creadoEn
      actualizadoEn
      cerradoEn
      categoria {
        id
        nombre
      }
      sla {
        slaId
        slaNombre
        promesaHoras
        primeraRespuestaMin
        mttaMin
        mttrMin
        cumplido
        evaluadoEn
      }
      comentarios {
        id
        autorTipo
        mensaje
        privado
        creadoEn
        userId
      }
      adjuntos {
        id
        url
        nombre
        tipoMime
        sizeBytes
        creadoEn
      }
      historial {
        id
        campo
        valorAnterior
        valorNuevo
        creadoEn
        userId
      }
    }
  }
`;

export const LIST_TICKET_CATEGORIAS = gql`
  query ListTicketCategorias {
    listTicketCategorias {
      id
      nombre
    }
  }
`;

export const LIST_SLA = gql`
  query ListSla($pagination: PaginationInput, $filters: SlaDefFilterInput) {
    listSLA(pagination: $pagination, filters: $filters) {
      items {
        id
        nombre
        tipoServicio
        zona
        promesaHoras
        primeraRespuestaMin
        activo
      }
      pageInfo {
        total
        limit
        offset
      }
    }
  }
`;

export const CREAR_TICKET = gql`
  mutation CrearTicket($input: CrearTicketInput!) {
    crearTicket(input: $input) {
      id
      asunto
    }
  }
`;

export const ACTUALIZAR_TICKET = gql`
  mutation ActualizarTicket($id: ID!, $input: ActualizarTicketInput!) {
    actualizarTicket(id: $id, input: $input) {
      id
      estado
      prioridad
      asignadoAUserId
    }
  }
`;

export const AGREGAR_COMENTARIO = gql`
  mutation AgregarComentario($input: ComentarioInput!) {
    agregarComentario(input: $input) {
      id
      mensaje
      autorTipo
      creadoEn
    }
  }
`;

export const AGREGAR_ADJUNTO = gql`
  mutation AgregarAdjunto($input: AdjuntoInput!) {
    agregarAdjunto(input: $input) {
      id
      url
      nombre
      tipoMime
      sizeBytes
      creadoEn
    }
  }
`;

export const CERRAR_TICKET = gql`
  mutation CerrarTicket($input: CerrarTicketInput!) {
    cerrarTicket(input: $input) {
      id
      estado
      cerradoEn
      sla {
        mttrMin
        mttaMin
        cumplido
      }
    }
  }
`;

export const EVALUAR_SLA = gql`
  query EvaluarSla($ticketId: ID!) {
    evaluarSLA(ticketId: $ticketId) {
      ticketId
      slaAplicada {
        slaNombre
        promesaHoras
        mttaMin
        mttrMin
        cumplido
        evaluadoEn
      }
    }
  }
`;
